import {Component, Input, OnInit} from "@angular/core";
import {Channel, ChannelConfig, ProfileConfig} from "../../../../model/channels.model";

@Component({
  selector: "admin-channels-view-profiles",
  templateUrl: "./profiles.component.html",
  styleUrls: ["./profiles.component.css"]
})
export class AdminChannelsViewProfilesComponent {

  @Input() default?: ChannelConfig;

  @Input() profiles?: ProfileConfig[];

  private _selected?: ProfileConfig;

  // createGeneric<T extends object>(
  //   ctor: new () => T,
  //   values: Partial<T>
  // ): T {
  //   const instance = new ctor();
  //   Object.assign(instance, values);
  //   return instance;
  // }

  get channel() {
    if (this.selected && this.selected.channel) {
      return this.selected?.channel;
    } else {
      let channel = new Channel();
      if (this.default) {
        channel.owner = this.default!.owner!;
        channel.vertical = this.default!.vertical!;
        channel.code = this.default!.code!;
      } else {
        return undefined;
      }
      return channel;
    }
  }

  get selected() {
    if (this._selected) {
      return this._selected;
    } else {
      if (this.profiles) {
        this.viewProfile(this.profiles![0]);
      }
      return this._selected;
    }
  }

  viewProfile(profile: ProfileConfig) {
    console.log(profile)
    this._selected = profile;
  }

}
